<div class="product-details-wrap">
    @if (!isPreview) {
        <div class="product-details-head">
            <h2>Product Detail</h2>
            <div class="product-details-head-action">
                @if (modelOrder?.status?.short_name === constants.SAMPLE_ORDER_REQUESTED_SHORT) {
                    <div class="scan-sku-box">
                        <input #skuInput type="text" placeholder="Scan SKU" class="form-control"
                               (input)="onSkuInput($event)"
                               [(ngModel)]="sampleProductSku" (keydown.enter)="onSkuEnterPress()"/>
                        <span class="scan-sku-code">
          <img src="{{constants.S3_BUCKET_URL}}/qr-code.svg" (error)="helperFunction.getErrorImage($event)"/>
        </span>
                    </div>
                }
                @if (hasExcessQuantityProduct && modelOrder.status.short_name !== constants.SAMPLE_ORDER_CANCELLED_SHORT) {
                    <button class="btn btn-secondary"
                            (click)="handleSampleRequestAction(modelOrder.id, isDisplaySplitDeliveryBtn)">
                        Split Delivery
                    </button>
                }
                @if (!(modelOrder.status.short_name == constants.SAMPLE_ORDER_DELIVERED_SHORT || modelOrder.status.short_name == constants.SAMPLE_ORDER_COMPLETED_SHORT || modelOrder.status.short_name == constants.SAMPLE_ORDER_DISPATCHED_SHORT || modelOrder.status.short_name == constants.SAMPLE_ORDER_FOLLOW_UP_SHORT || modelOrder.status.short_name == constants.SAMPLE_ORDER_CANCELLED_SHORT || modelOrder.status.short_name == constants.SAMPLE_ORDER_CONVERSION_PENDING_SHORT || modelOrder.status.short_name == constants.SAMPLE_ORDER_CONVERTED_SHORT || modelOrder.status.short_name == constants.SAMPLE_ORDER_UNCONVERTED_SHORT)) {
                    <button class="btn" (click)="toggle($event)">
                        Add Item
                    </button>
                }
            </div>
        </div>
    }
    <div class="product-details-table sample-request-page" [ngClass]="{'sticky-header-enabled': isStickyHeader}">
        <table>
            <thead>
            <tr>
                <th>#</th>
                <th>Product Description</th>
                <th>Bin Location</th>
                <th>Thickness <br> <small>(mm)</small></th>
                <th>Material</th>
                <th>Edge</th>
                <th class="text-center">Required Qty</th>
                <th class="text-center">Packed Qty</th>
                <th>Camera</th>
                <!-- <th class="action-th">Action</th> -->
                <th class="action-th pro-table-action display-table-cell">
                    <!--          <img src="/assets/admin/images/comment-icon.svg" width="22" height="22" [ngClass]="{'added-comment': hasProductCommentAdded ? productsRow.note.trim() : ''}" [attr.aria-expanded]="productsRow.isCommentExpanded" -->
                    <!--               alt="comment-icon" tooltip="Click to open/close all existing comments" placement="left"-->
                    <!--               tooltipClass="order-status-tooltip-custom-class" container="body">-->
                    @if (!isOrderCancel) {
                        <button type="button" class="btn" [tooltip]="'Click to open/close all existing comments'"
                                [placement]="'left'"
                                container="body" containerClass="comment-tooltip"
                                [class.added-comment]="hasProductCommentAdded()"
                                (click)="displayAllComments()">
                            <img src="/assets/admin/images/comment-icon.svg" width="22" height="22" class="comment-icon"
                                 alt="comment-icon">
                            <img src="/assets/admin/images/comment-fill-icon.svg" width="22" height="22"
                                 class="comment-fill-icon"
                                 alt="comment-fill-icon">
                        </button>
                    }
                </th>
            </tr>
            </thead>
            @for (productsRow of modelOrder.quote_product; track ('product-' + productsRow.id); let i = $index) {
                <tbody dndSortable [dndList]="modelOrder.quote_product" (dndListChanged)="onProductOrderChanged($event)"
                       [class.dropped-zone]="productsRow.order_index == hoveredProductIndex && productsRow.order_index !== draggedProductIndex"
                       [class.dragged-item]="productsRow.order_index === draggedProductIndex" dndDropzone
                       [dndObject]="productsRow"
                       (dndDrop)="onProductRowDrop($event, productsRow)" [dndDraggable]="productsRow"
                       [dndEffectAllowed]="'move'"
                       (dndStart)="onProductRowDragStart(productsRow)" (dndEnd)="onProductRowDragEnd($event)"
                       (dndDragover)="onProductRowDragOver($event, productsRow)">
                <tr>
                    <td>
                        <div class="pro-no">{{ i + 1 }}</div>
                    </td>
                    <td>
                        <div class="table-pro-info-box">
                            <div class="table-pro-info-img" (click)="openSliderModal(productsRow)">
                                <img src="{{ productImage(productsRow) }}" alt=""
                                     (error)="helperFunction.getErrorImage($event)"
                                     width="70" height="70"/>
                            </div>
                            <div class="table-pro-info">
                                <h3>
                                    {{ productsRow?.product?.sample_product?.family?.name }}
                                    <span class="generate-sample-icon cursor-pointer"
                                          [tooltip]="'Generate Sample Sticker'"
                                          [containerClass]="'customClass'" [adaptivePosition]="true" container="body"
                                          (click)="generateSticker(productsRow)">
                    <img src="/assets/admin/images/sample-download-icon.svg" width="18" height="18"
                         alt="sample-download-icon">
                  </span>
                                    <span class="generate-sample-icon cursor-pointer"
                                          [tooltip]="productsRow?.product?.sample_product?.sample_product_description?.short_description || 'Add sample product note'"
                                          [containerClass]="'customClass'" [adaptivePosition]="true" container="body"
                                          (click)="openProductNotesModal(productsRow, $event)">
                                        @if (productsRow?.product?.sample_product?.sample_product_description?.short_description) {
                                            <img src="/assets/admin/images/info-circle-icon.svg" width="18" height="18"
                                                 alt="info-icon" (error)="helperFunction.getErrorImage($event)"/>
                                        } @else {
                                            <svg class="add-notes-plus" width="18" height="18" viewBox="0 0 18 18" fill="none" aria-label="Add sample product note">
                                                <circle cx="9" cy="9" r="7.25" stroke="currentColor" stroke-width="1.4"/>
                                                <path d="M9 5.75v6.5M5.75 9h6.5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
                                            </svg>
                                        }
                                    </span>
                                    @if (isDisplayMarkIcon(productsRow)) {
                                        <span class="check-sample-icon">
                    <img src="/assets/admin/images/green-check-icon.svg" alt="green-check-icon"
                         (error)="helperFunction.getErrorImage($event)"/>
                  </span>
                                    }
                                </h3>
                                <p>
                                    {{ productsRow?.product?.join_product_type_collection_category[0]?.product_collection?.name }}{{
                                        productsRow?.product?.join_product_type_collection_category[0]?.product_category?.name ? " - " +
                                            productsRow?.product?.join_product_type_collection_category[0]?.product_category?.name : ''
                                    }}
                                </p>
                                <p>
                                    {{ productsRow?.product?.finish?.name || "-" }}
                                </p>
                                <p>
<!--                                    {{-->
<!--                                        productsRow?.product?.length && productsRow?.product?.width ? (productsRow.product.length + ' x '-->
<!--                                            + productsRow.product.width) : "—"-->
<!--                                    }}-->
                                    {{ productsRow?.product ? getSizingDimensions(productsRow?.product) : '-' }}
                                </p>

                                <div class="table-pro-no">
                                    <div class="table-pro-no-link" [ngbPopover]="sampleRequestDetail" [autoClose]="true"
                                         [placement]="'top'" triggers="click"
                                         #srd="ngbPopover" popoverClass="warehouse-info">
                                        {{ productsRow.product?.sample_product?.sku }}
                                        <ng-template #sampleRequestDetail>
                                            <div
                                                class="warehouse-pro-name">{{ productsRow.product?.sample_product?.sku }}
                                            </div>
                                            <div class="warehouse-short-des"
                                                 [innerText]="productsRow.product?.sample_product?.ul_bin_location"></div>
                                            <div class="warehouse-title">Main Warehouse</div>
                                            <ul>
                                                <li>
                                                    Stock On Hand
                                                    <strong>
                                                        {{
                                                            productsRow.product?.sample_product?.ul_stock_on_hand
                                                                ?
                                                                productsRow.product?.sample_product?.ul_stock_on_hand :
                                                                0
                                                        }}
                                                    </strong>
                                                </li>
                                                <li>
                                                    Allocated Qty
                                                    <strong>
                                                        {{
                                                            productsRow.product?.sample_product?.ul_allocated_qty
                                                                ?
                                                                productsRow.product?.sample_product?.ul_allocated_qty :
                                                                0
                                                        }}
                                                    </strong>
                                                </li>
                                                <li>
                                                    Available Qty
                                                    <strong>
                                                        {{
                                                            productsRow.product?.sample_product?.ul_available_qty
                                                                ?
                                                                productsRow.product?.sample_product?.ul_available_qty :
                                                                0
                                                        }}
                                                    </strong>
                                                </li>
                                                <li>
                                                    On Purchase
                                                    <strong>
                                                        {{
                                                            productsRow.product?.sample_product?.ul_on_purchase ?
                                                                productsRow.product?.sample_product?.ul_on_purchase :
                                                                0
                                                        }}
                                                    </strong>
                                                </li>
                                            </ul>
                                        </ng-template>
                                    </div>

                                    <img src="/assets/admin/images/copy-icon.svg" width="12" height="13" alt="copy-icon"
                                         (click)="copySku(productsRow.product?.sample_product?.sku);$event.stopImmediatePropagation();"
                                         tooltip="Copy SKU Code" placement="top" container="body"/>
                                </div>
                            </div>
                        </div>
                    </td>
                    <td>
                        {{
                            productsRow?.product?.sample_product?.ul_bin_location ?
                                productsRow?.product.sample_product?.ul_bin_location : '-'
                        }}
                    </td>
                    <td>
                        {{
                            productsRow?.product?.sample_product?.thickness ?
                                productsRow?.product?.sample_product?.thickness.replace('mm', '') : '-'
                        }}
                    </td>
                    <td>
                        {{
                            productsRow?.product?.material?.name ?
                                productsRow?.product?.material?.name : '-'
                        }}
                    </td>
                    <td>
                        {{
                            productsRow?.product?.sample_product?.finish_edge_name ?
                                productsRow?.product?.sample_product?.finish_edge_name : '-'
                        }}
                    </td>
                    <td class="text-center">
                        {{ productsRow?.quantity ? productsRow?.quantity : '-' }}
                    </td>
                    <td class="text-center">
                        @if ((modelOrder?.status?.short_name == constants.SAMPLE_ORDER_REQUESTED_SHORT ||
                            modelOrder?.status?.short_name == constants.SAMPLE_ORDER_PACKING_SHORT) && !isPreview) {
                            <div class="pro-qty-box">
                                <div class="pro-qty">
                                    <button class="btn" (click)="checkQuantity(productsRow, 'decrement')">
                                        <img src="/assets/admin/images/small-minus-icon.svg" width="12" height="2"
                                             alt="small-minus-icon"/>
                                    </button>
                                    <input #enteredQuantity type="text" autocomplete="off"
                                           [disabled]="modelOrder?.is_archive == constants.IS_ARCHIVE_YES && modelOrder?.status?.short_name !== constants.SAMPLE_ORDER_UNCONVERTED_SHORT"
                                           value="{{ productsRow.packed_quantity ? productsRow.packed_quantity : 0 }}"
                                           (keypress)="restrictToDigits($event)" pattern="[0-9]+" maxlength="4"
                                           appDecimalInput
                                           (input)="checkQuantityOnKeyPress(productsRow, 'text', enteredQuantity.value)">
                                    <button class="btn" (click)="checkQuantity(productsRow, 'increment')">
                                        <img src="/assets/admin/images/small-plus-icon.svg" width="12" height="12"
                                             alt="small-plus-icon"/>
                                    </button>
                                </div>
                            </div>
                        } @else {
                            {{ productsRow?.packed_quantity || 0 }}
                        }
                    </td>

                    <td (click)="openSampleImageModal(productsRow.id, productsRow)">
                        @if (productsRow?.sample_packing_image?.length > 0) {
                            <div class="uploaded-image-box">
                                <img src="{{getSampleImage(productsRow.sample_packing_image[0].original_file_name)}}"
                                     (error)="helperFunction.getErrorImage($event, 'default_profile.png')" width="40"
                                     height="40"
                                     alt="User Image">
                                <span class="remove-img" tooltip="Delete Sample Packing Image"
                                      [ngStyle]="{cursor: (modelOrder?.status?.short_name == constants.SAMPLE_ORDER_CANCELLED_SHORT || modelOrder.status.short_name == constants.SAMPLE_ORDER_CONVERSION_PENDING_SHORT || modelOrder.status.short_name == constants.SAMPLE_ORDER_CONVERTED_SHORT || modelOrder.status.short_name == constants.SAMPLE_ORDER_UNCONVERTED_SHORT) ? 'not-allowed' : 'pointer'}"
                                      (click)="$event.stopImmediatePropagation();deleteSamplePackingImage(productsRow.sample_packing_image[0].id)"><img
                                    src="/assets/admin/images/label-close-icon.svg" width="16" height="16"
                                    alt="close-icon"></span>
                            </div>
                        } @else {
                            <img src="/assets/admin/images/camera-icon.svg" width="20" height="18" alt="camera-icon"
                                 tooltip="Take & Upload Sample Packing Image" placement="top" container="body"
                                 [ngStyle]="{cursor: (modelOrder?.status?.short_name == constants.SAMPLE_ORDER_CANCELLED_SHORT || modelOrder.status.short_name == constants.SAMPLE_ORDER_CONVERSION_PENDING_SHORT || modelOrder.status.short_name == constants.SAMPLE_ORDER_CONVERTED_SHORT || modelOrder.status.short_name == constants.SAMPLE_ORDER_UNCONVERTED_SHORT) ? 'not-allowed' : 'pointer'}">
                        }
                    </td>
                    <td>
                        <div class="pro-table-action">
                            @if (!isPreview && (modelOrder?.status?.short_name == constants.SAMPLE_ORDER_REQUESTED_SHORT ||
                                modelOrder?.status?.short_name == constants.SAMPLE_ORDER_PACKING_SHORT)) {
                                <button type="button" class="btn">
                                    <img src="{{ s3BucketImageURL }}/delete-icon.svg"
                                         (click)="removeProduct(productsRow)"
                                         tooltip="Remove Product" placement="top" container="body"
                                         (error)="helperFunction.getErrorImage($event)" width="22" height="22"
                                         alt="comment-icon"/>
                                </button>
                            }

                            @if (!isOrderCancel) {
                                <button type="button" class="btn" [tooltip]="HtmlContent" [placement]="'left'"
                                        container="body"
                                        containerClass="comment-tooltip"
                                        [ngClass]="{'added-comment': productsRow.note && productsRow.note.trim() !== '',
                'active': productsRow.isCommentExpanded}"
                                        [attr.aria-expanded]="productsRow.isCommentExpanded"
                                        (click)="toggleCommentIcon(productsRow)"
                                        aria-controls="collapse_comment">
                                    <img src="/assets/admin/images/comment-icon.svg" width="22" height="22"
                                         class="comment-icon"
                                         alt="comment-icon">
                                    <img src="/assets/admin/images/comment-fill-icon.svg" width="22" height="22"
                                         class="comment-fill-icon"
                                         alt="comment-fill-icon">
                                </button>
                            }

                            <ng-template #HtmlContent>
                                <div [innerHtml]="getCommentTooltip(productsRow.note)"
                                     class="comment-tooltip-content"></div>
                            </ng-template>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td colspan="10" [id]="'collapse_comment_' + productsRow.id" class="pt-0 pb-0 conditions-details">
                        <div [ngbCollapse]="!productsRow.isCommentExpanded">
                            <div class="collapse-content">
                                <div class="editor-container" #editorContainer [id]="productsRow.id"
                                     data-id="{{ productsRow.id }}">
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
                </tbody>
            }
        </table>
    </div>
</div>
